<app-collapsible-container
    [id]="id ? id : 'schedules'"
    [title]="'REPERTOIRE.FORMS.SCHEDULES.TITLE'"
    [icon]="'i-calendar'"
    (elementSizeModification)="elementSizeModification.emit()"
>
    <div class="horizontal">
        <span class="schedule-label">{{ 'ENUM.WEEK-DAYS.ABBREVIATION.MONDAY' | translate }}</span>
        <app-time-range-input
            [endTimePlaceholder]="endTimePlaceholder"
            [formGroup]="monday"
            [inputId]="'monday'"
            [startTimePlaceholder]="startTimePlaceholder"
            (elementSizeModification)="elementSizeModification.emit()"
            [readonly]="{ start: readonly, end: readonly }"
        >
        </app-time-range-input>
    </div>

    <div class="horizontal">
        <span class="schedule-label">{{ 'ENUM.WEEK-DAYS.ABBREVIATION.TUESDAY' | translate }}</span>
        <app-time-range-input
            [endTimePlaceholder]="endTimePlaceholder"
            [formGroup]="tuesday"
            [inputId]="'tuesday'"
            [startTimePlaceholder]="startTimePlaceholder"
            (elementSizeModification)="elementSizeModification.emit()"
            [readonly]="{ start: readonly, end: readonly }"
        >
        </app-time-range-input>
    </div>

    <div class="horizontal">
        <span class="schedule-label">{{ 'ENUM.WEEK-DAYS.ABBREVIATION.WEDNESDAY' | translate }}</span>
        <app-time-range-input
            [endTimePlaceholder]="endTimePlaceholder"
            [formGroup]="wednesday"
            [inputId]="'wednesday'"
            [startTimePlaceholder]="startTimePlaceholder"
            (elementSizeModification)="elementSizeModification.emit()"
            [readonly]="{ start: readonly, end: readonly }"
        >
        </app-time-range-input>
    </div>

    <div class="horizontal">
        <span class="schedule-label">{{ 'ENUM.WEEK-DAYS.ABBREVIATION.THURSDAY' | translate }}</span>
        <app-time-range-input
            [endTimePlaceholder]="endTimePlaceholder"
            [formGroup]="thursday"
            [inputId]="'thursday'"
            [startTimePlaceholder]="startTimePlaceholder"
            (elementSizeModification)="elementSizeModification.emit()"
            [readonly]="{ start: readonly, end: readonly }"
        >
        </app-time-range-input>
    </div>

    <div class="horizontal">
        <span class="schedule-label">{{ 'ENUM.WEEK-DAYS.ABBREVIATION.FRIDAY' | translate }}</span>
        <app-time-range-input
            [endTimePlaceholder]="endTimePlaceholder"
            [formGroup]="friday"
            [inputId]="'friday'"
            [startTimePlaceholder]="startTimePlaceholder"
            (elementSizeModification)="elementSizeModification.emit()"
            [readonly]="{ start: readonly, end: readonly }"
        >
        </app-time-range-input>
    </div>
</app-collapsible-container>
